/**
 * Forms written for particular actions, keyed by action name alone: the same
 * action is owned by different orgs on different stacks (`roboto-public` in
 * production, a test org on a dev stack), so the owner is not part of the key.
 * Every other action gets the generic parameter list.
 *
 * An org's own action that takes one of these names gets the form too. Every
 * parameter the form does not cover is listed under "More parameters", and
 * each control shows its own key's validation error.
 */

import { CsvIngestionForm } from "./CsvIngestionForm";
import { ParquetIngestionForm } from "./ParquetIngestionForm";
import { RosIngestionForm } from "./RosIngestionForm";
import { type ParameterFormDefinition } from "./types";
import { UlogIngestionForm } from "./UlogIngestionForm";

const PARAMETER_FORMS: Readonly<Record<string, ParameterFormDefinition>> = {
  ros_ingestion: {
    Form: RosIngestionForm,
    resourcesHint: "Large bags may need more memory and disk.",
  },
  csv_ingestion: { Form: CsvIngestionForm },
  parquet_ingestion: { Form: ParquetIngestionForm },
  ulog_ingestion: { Form: UlogIngestionForm },
};

/** The form written for the action named `actionName`, if there is one. */
export function parameterFormFor(
  actionName: string | undefined,
): ParameterFormDefinition | undefined {
  if (actionName === undefined) {
    return undefined;
  }
  return Object.hasOwn(PARAMETER_FORMS, actionName)
    ? PARAMETER_FORMS[actionName]
    : undefined;
}
